// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2AHFb","description":"PatientConsentPreview_description__2kexi"};